import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0% { opacity: 0.6; transform: scale(0.98); }
  50% { opacity: 1; transform: scale(1); }
  100% { opacity: 0.6; transform: scale(0.98); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${props => props.theme.glass};
  padding: 40px;
  border-radius: 24px;
`;

const Spinner = styled.div`
  width: ${props => props.size === 'small' ? '40px' : '64px'};
  height: ${props => props.size === 'small' ? '40px' : '64px'};
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top: 3px solid ${props => props.theme.colors.secondary};
  border-radius: 50%;
  animation: ${rotate} 0.8s linear infinite;
  margin-bottom: 20px;
`;

const Text = styled.div`
  font-family: ${props => props.theme.fonts.title};
  font-size: ${props => props.size === 'small' ? '0.85rem' : '1.1rem'};
  color: ${props => props.theme.colors.text};
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const LoaderRing = ({ size, texto }) => {
  return (
    <Overlay>
      <LoaderContainer>
        <Spinner size={size} />
        <Text size={size}>{texto || 'Cargando...'}</Text>
      </LoaderContainer>
    </Overlay>
  );
};

export default React.memo(LoaderRing);